export default __webpack_public_path__ + "static/media/DFMingStd-W9.622151b9.otf";